// uses ./appSuggestion.less
import PropTypes from 'prop-types';

import React from 'react';
import CustomModal from '../common/CustomModal';

function SuggestionSubmittedModal(props) {
    const closeButton = {
        className: 'sg-button-link appSuggestion-close',
        label: 'Close',
        handler: props.closeSuggestion,
        key: 'close_button',
    };

    return (
        <CustomModal
            className="appSuggestion"
            closeHandler={props.closeSuggestion}
            title={`Thank you ${props.displayName}!`}
            buttons={[closeButton]}
        >
            <p className="section">
                We received your request and are looking into it. We’ll inform you soon if it&apos;s possible for us to
                create the integration you suggested.
            </p>
            <p className="section">
                Sincerely,
                <br />
                Product Team, Egnyte Inc.
            </p>
        </CustomModal>
    );
}

SuggestionSubmittedModal.propTypes = {
    closeSuggestion: PropTypes.func.isRequired,
    displayName: PropTypes.string.isRequired,
};

export default SuggestionSubmittedModal;
